import Box, { BoxProps } from "@mui/material/Box";
import { visuallyHidden } from "@mui/utils";

/**
 * Provides a visually hidden element for screen readers
 *
 * @example
 *   <VisuallyHidden>Hidden text</VisuallyHidden>
 *   <VisuallyHidden>
 *     <p>Hidden text</p>
 *     <p>With some more details</p>
 *   </VisuallyHidden>
 */
export const VisuallyHidden = ({ children, ...props }: BoxProps): JSX.Element => {
  return (
    <Box component="span" sx={visuallyHidden} {...props}>
      {children}
    </Box>
  );
};
